import { render, staticRenderFns } from "./PimRequestModal.vue?vue&type=template&id=2a63e403&scoped=true&"
import script from "./PimRequestModal.vue?vue&type=script&lang=js&"
export * from "./PimRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./PimRequestModal.vue?vue&type=style&index=0&id=2a63e403&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a63e403",
  null
  
)

export default component.exports